import React from "react";
import Spanish from "./Languages/Spanish";
import Swahili from "./Languages/Swahili";
import Creole from "./Languages/Creole";

const CoursesFlat = () => {

  return (
<>
    <div style={{display:"flex"}}>
      <div><Creole/></div>
      <div><Spanish/></div>
      <div><Swahili/></div>
    </div>
</>
  );
};
export default CoursesFlat;
